import React from 'react';
import { Paper } from '@material-ui/core';
import { cardSx, SPACE } from '../theme';

const SectionCard = ({ children, style, noPadding, ...rest }) => (
  <Paper
    elevation={0}
    style={{ ...cardSx, padding: noPadding ? 0 : SPACE.md, ...style }}
    {...rest}
  >
    {children}
  </Paper>
);

export default SectionCard;
